
import React from 'react';
import { LeadContact } from '@/components/leads/types';
import { DetailItem } from '../DetailItem';
import { Users, Mail, Phone, Briefcase, Globe } from 'lucide-react';

interface PrimaryContactSectionProps {
  primaryContact?: LeadContact;
}

export const PrimaryContactSection: React.FC<PrimaryContactSectionProps> = ({ primaryContact }) => {
  if (!primaryContact) {
    return null;
  }

  return (
    <div className="py-4">
      <h3 className="text-md font-semibold mb-3 text-gray-800 flex items-center"><Users size={18} className="mr-2 text-primary"/>Primary Contact</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1">
        <DetailItem icon={<Mail size={16} />} label="Email" value={primaryContact?.email} />
        <DetailItem icon={<Phone size={16} />} label="Phone" value={primaryContact?.phone} />
        <DetailItem icon={<Briefcase size={16} />} label="Contact Title" value={primaryContact?.title} />
        {primaryContact?.linkedin_url && (
          <DetailItem
            icon={<Globe size={16} />}
            label="LinkedIn Profile"
            value="View Profile"
            isLink={true}
            linkHref={primaryContact.linkedin_url}
            linkText="View Profile"
          />
        )}
      </div>
    </div>
  );
};
